<template>
  <div class="global-van-notify">
    <van-notify v-model="show" :type="notifyType">
      <div class="global-van-notify-content">
        <van-icon name="clear" class="global-van-notify-clear display-middle" @click="close" v-if="notifyType === 'danger'" />
        <van-icon name="checked" class="global-van-notify-success display-middle" @click="close" v-if="notifyType === 'success'" />
        <div class="global-van-notify-txt display-middle" v-text="content" />
      </div>
    </van-notify>
  </div>
</template>

<script>
import Notify from 'vant/lib/notify/index';
import { Icon } from 'vant';
import 'vant/lib/notify/style/index';
Vue.use(Icon);
export default {
  components: { [Notify.Component.name]: Notify.Component },
  data() {
    return {
      show: false,
      notifyType: 'danger',
      content: '',
      closeTime: 5000
    };
  },
  watch: {
    show(val) {
      if (!!val && this.closeTime) {
        this.$nextTick(() => {
          this.$root.timeout(() => {
            this.show = false;
          }, this.closeTime);
        });
      }
    }
  },
  mounted() {
    Vue.filter('show-message', ({ type = 'danger', content = '', closeTime }) => {
      this.notifyType = type;
      this.content = content;
      this.show = true;
      this.closeTime = closeTime || this.closeTime;
    });
  },
  methods: {
    close() {
      this.show = false;
    }
  }
}
</script>

<style lang="stylus">
  .global-van-notify {
    .van-notify {
      min-height: 64px;
      padding: 10px 0;
      box-sizing: border-box;
      transition-duration: 0.1s !important;
      z-index: 5000 !important;
    }
    .van-notify--danger {
      background-color: #5D667F;
    }
    .global-van-notify-content {
      width: 100%;
      text-align: left;
      position: relative;
      padding-left: 15px;
      box-sizing: border-box;
    }
    .van-icon {
      padding-top: 2px;
      font-size: 20px;
      vertical-align: top;
    }
    .global-van-notify-clear {
      color: #ADB6C8;
    }
    .global-van-notify-success {
      color: #fff;
    }
    .global-van-notify-txt {
      margin-left: 10px;
      font-size: 16px;
      width: 312px;
    }
    .van-notify--success{
      background-color #07c160
    }
  }
</style>